module.exports = __webpack_public_path__ + "static/img/layout1.fcddb6d0.png";